import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { SITE } from "../data/site";

const NAV_LINKS = [
  { label: "Work", target: "work" },
  { label: "About", target: "about" },
  { label: "Services", target: "services" },
  { label: "Contact", target: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const onHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (target) => {
    setOpen(false);
    if (onHome) {
      const el = document.getElementById(target);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${target}`);
    }
  };

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || open
          ? "bg-black/70 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <Link
          to="/"
          data-testid="nav-logo"
          className="font-display text-base md:text-lg tracking-tight uppercase"
          onClick={() => setOpen(false)}
        >
          {SITE.shortName}
          <span className="text-[#f5e6d3]">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.target}
              data-testid={`nav-link-${l.target}`}
              onClick={() => handleNav(l.target)}
              className="font-body text-sm tracking-wide text-zinc-300 hover:text-[#f5e6d3] transition-colors uppercase"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => handleNav("contact")}
            className="font-display text-xs uppercase tracking-[0.2em] border border-white/20 px-5 py-2.5 rounded-full hover:bg-[#f5e6d3] hover:text-black hover:border-[#f5e6d3] transition-all"
          >
            Let's talk
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2"
          onClick={() => setOpen((o) => !o)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <button
                key={l.target}
                data-testid={`nav-mobile-link-${l.target}`}
                onClick={() => handleNav(l.target)}
                className="font-display text-2xl text-left uppercase tracking-tight hover:text-[#f5e6d3] transition-colors"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
